<template>
  <div id="contenedor-listado-documentos-detalles">
    <div class="pa-3 rounded-lg">
      <v-row no-gutters>
        <v-col
          cols="12"
          md="6">
          <h4>Observación: {{detalle.observacionDetalle.auditoriaObservacion.numero}}</h4>
          <p>
            <cortar-texto
              v-if="detalle.observacionDetalle.auditoriaObservacion.descripcion"
              :texto="detalle.observacionDetalle.auditoriaObservacion
                ? detalle.observacionDetalle.auditoriaObservacion.descripcion
                : ''">
            </cortar-texto>
          </p>
        </v-col>
        <v-col
          cols="12"
          md="6">
          <h4>Contrato:</h4>
          <p>
            <span class="font-weight-bold primary--text">
              {{ detalle.observacionDetalle.contrato.numero }}
            </span>
          </p>
        </v-col>
      </v-row>
      <div class="d-block">
        <v-chip
          :disabled="!detalle.esRespuestaParcial"
          :color="detalle.esRespuestaParcial ? 'warning' : 'grey'">
          Es Respuesta Parcial
        </v-chip>
      </div>
      <v-row no-gutters class="mt-3 pa-3 grey lighten-3 rounded-lg">
        <p>
          <cortar-texto
            v-if="detalle.observacionDetalle"
            :texto="detalle.observacionDetalle
              ? detalle.observacionDetalle.texto
              : ''">
          </cortar-texto>
        </p>
      </v-row>
      <v-row>
        <span class="text-caption font-weight-light base3--text"
        v-if="detalle.comentarios">
          <cortar-texto
          :texto="detalle.comentarios!='' && detalle.comentarios!=null
          ? detalle.comentarios : ''">
          </cortar-texto>
        </span>
      </v-row>
    </div>
    <v-divider class="my-3"></v-divider>
    <v-row align="center">
      <h3>Archivos:</h3>
      <v-chip
        class="mx-2"
        small>
        {{ getDetalleDocumentos.length }}
      </v-chip>
      <v-spacer></v-spacer>
      <v-btn
        v-if="mixValidaScopesActions(1)"
        color="primary"
        rounded
        small
        @click="mostrarAgregarDocumento = !mostrarAgregarDocumento"
      >
        <v-icon left>
          mdi-file-plus
        </v-icon>
        Agregar archivo
      </v-btn>
    </v-row>
    <v-divider class="my-4"></v-divider>
    <template v-if="$apollo.loading">
      <v-row class="fill-height" align-content="center" justify="center">
        <v-col class="text-subtitle-1 text-center" cols="12">
          Cargando archivos
        </v-col>
        <v-col cols="6">
          <v-progress-linear color="primary" indeterminate rounded height="6"></v-progress-linear>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <template v-if="getDetalleDocumentos.length < 1">
      <v-row justify="center" class="py-4">
        <v-alert dense color="info" class="white--text">
          Sin archivos registrados.
        </v-alert>
      </v-row>
    </template>
    <template v-else>
      <v-list class="overflow-y-auto">
        <template v-for="documento in getDetalleDocumentos">
          <template>
            <v-hover v-slot="{ hover }" :key="`hover-${documento.datosArchivo.name}`">
              <v-list-item
                :key="documento.datosArchivo.name"
                class="my-0 mx-0"
                :class="{ 'grey lighten-4': hover }"
              >
                <v-list-item-avatar>
                  <v-icon>
                    {{ $iconoDeExtension(documento.datosArchivo.extension) }}
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ documento.nombre }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption">
                    {{ $moment(documento.createdAt).format("DD/MM/YYYY") }} -
                    <span>
                      <FechaHumano :fecha="documento.createdAt"></FechaHumano>
                    </span>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    {{ documento.descripcion }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <div class="d-flex">
                    <div>
                      <v-btn
                        v-if="mixValidaScopesActions(0)"
                        @click="mixDescargarDocumento(documento)"
                        :loading="descargandoArchivo"
                        icon
                      >
                        <v-icon color="success">mdi-download</v-icon>
                      </v-btn>
                    </div>
                    <div>
                      <v-btn
                      v-if="mixValidaScopesActions(0)"
                      @click="verPdf(documento)" icon>
                        <v-icon color="blue">mdi-eye</v-icon>
                      </v-btn>
                    </div>
                    <div>
                      <v-btn
                      v-if="mixValidaScopesActions(3)"
                      @click="borrarDocumento(documento)" icon>
                        <v-icon color="red">mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-list-item-action>
              </v-list-item>
            </v-hover>
          </template>
        </template>
      </v-list>
    </template>
    </template>
    <v-dialog v-if="mostrarAgregarDocumento" v-model="mostrarAgregarDocumento" width="400">
      <AgregarDocumento :idDetalle="detalle.id" :idRespuesta="idRespuesta" v-on:cerrar="cerrar" />
    </v-dialog>
    <v-dialog v-if="esteDetalleDocumento" v-model="mostrarEliminarDocumento" width="400">
      <EliminarDocumento :detalleDocumentoEliminar="esteDetalleDocumento" :idRespuesta="idRespuesta"
      v-on:cerrar="cerrar" />
    </v-dialog>
    <v-dialog
      v-if="esteDetalleDocumento"
      v-model="mostrarVerPdf"
      persistent
      scrollable
      width="750px"
    >
      <v-card>
        <v-card-title class="secondary--text">
          {{ esteDetalleDocumento.nombre }}
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar()">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <VistaPreviaPdf :ruta-archivo="esteDetalleDocumento.fileData"> </VistaPreviaPdf>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AUDITORIA_INFORME_RESPUESTA_DETALLE_DOCUMENTOS from '@/graphql/querys/administracion/auditorias/auditoriaInformeRespuestaDetalleDocumentos.gql';
import FechaHumano from '@/components/FechaHumano.vue';
import VistaPreviaPdf from '@/components/administracion/auditorias/informes/verPdf.vue';
import CortarTexto from '@/components/CortarTextos.vue';
import mixAuditoriaRespuestaDetalleDocumentos from './mixAuditoriaRespuestaDetalleDocumentos';
import AgregarDocumento from './Agregar.vue';
import EliminarDocumento from './Eliminar.vue';

export default {
  name: 'ListadoDocumentosDetalles',
  mixins: [mixAuditoriaRespuestaDetalleDocumentos],
  props: {
    detalle: {
      type: Object,
      requiered: true,
    },
    idRespuesta: {
      type: String,
      requiered: true,
    },
  },
  components: {
    AgregarDocumento,
    EliminarDocumento,
    FechaHumano,
    VistaPreviaPdf,
    CortarTexto,
  },
  apollo: {
    auditoriaInformeRespuestaDetalleDocumentos: {
      query: AUDITORIA_INFORME_RESPUESTA_DETALLE_DOCUMENTOS,
      variables() {
        return {
          idAuditoriaInformeRespuestaDetalle: this.detalle.id,
        };
      },
    },
  },
  data() {
    return {
      supportedFileExtension: ['pdf'],
      descargandoArchivo: false,
      mostrarAgregarDocumento: false,
      mostrarEliminarDocumento: false,
      mostrarVerPdf: false,
      esteDetalleDocumento: null,
    };
  },
  methods: {
    verPdf(documento) {
      this.esteDetalleDocumento = documento;
      this.mostrarVerPdf = true;
    },
    borrarDocumento(documento) {
      this.esteDetalleDocumento = documento;
      this.mostrarEliminarDocumento = true;
    },
    cerrar() {
      this.mostrarAgregarDocumento = false;
      this.mostrarEliminarDocumento = false;
      this.mostrarVerPdf = false;
      this.esteDetalleDocumento = null;
    },
  },
  computed: {
    getDetalleDocumentos() {
      if (!this.auditoriaInformeRespuestaDetalleDocumentos) return [];
      return this.auditoriaInformeRespuestaDetalleDocumentos.slice().map((detalleDocumento) => ({
        ...detalleDocumento,
        datosArchivo: JSON.parse(detalleDocumento.fileData),
      }));
    },
  },
};
</script>

<style lang="scss" scoped></style>
